import React from 'react';
import Styled from 'styled';
import { Query } from '@apollo/client/react/components';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';
import LoadingProgress from 'lib/react-router/loading-progress';
import SVGIconView from 'lib/images/svg-icon-view';

import ErrorPage from 'four-nets/errors/error-page';
import message from 'four-nets/icons/svg/icon_message.svg';

import query, { PopularThreadsQuery, PopularThreadsQueryVariables } from './popular-threads.graphql';
import defaultStyles from './popular-threads.scss';

export interface Props {
    category: string;
    categorySlug: string;
    styles: typeof defaultStyles;
}

class PopularThreads extends React.PureComponent<Props> {
    render() {
        const { styles, category, categorySlug } = this.props;
        return (
            <Query<PopularThreadsQuery, PopularThreadsQueryVariables>
                query={query}
                variables={{
                    category,
                }}
            >
                {({ data, loading, error }) => (
                    <LoadingProgress loading={loading}>
                        <ErrorPage error={error}>
                            {data && data.popularThreads && data.popularThreads.edges ? (
                                <div className={styles.wrapper}>
                                    <FormattedMessage id='POPULAR_THREADS_FROM'>
                                        {msg => <span className={styles.wrapperTitle}>{msg + ' ' + category}</span>}
                                    </FormattedMessage>
                                    {data.popularThreads.edges.map(edge =>
                                        edge && edge.node ? (
                                            <div key={edge.node.id} className={styles.thread}>
                                                <div className={styles.innerWrapper}>
                                                    <Link
                                                        className={styles.title}
                                                        to={`/forum/${categorySlug}/${edge.node.slug}/`}
                                                    >
                                                        {edge.node.title}
                                                    </Link>
                                                    <div className={styles.info}>
                                                        <div className={styles.date}>
                                                            <FormattedDateAgoView
                                                                value={new Date(edge.node.lastMessage.time)}
                                                            />
                                                        </div>
                                                        <div className={styles.message}>
                                                            <SVGIconView src={message} className={styles.messageIcon} />
                                                            <span className={styles.messageText}>
                                                                {edge.node.messageCount}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    )}
                                </div>
                            ) : null}
                        </ErrorPage>
                    </LoadingProgress>
                )}
            </Query>
        );
    }
}

export default Styled(defaultStyles)(PopularThreads);
